import React, { Fragment } from 'react';
export var nl2br = function (string) {
    if (string && string !== null && string !== '') {
        return string.split('\n').map(function (item, key) { return (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Fragment, { key: key },
            item,
            React.createElement("br", null))); });
    }
    return string;
};
